module.exports = __webpack_public_path__ + "static/media/n_service-report-bg.40a73b14.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/n_service-report-bg.png
// module id = 1821
// module chunks = 0 1